import { faPlus, faSave, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Alert, Button, Form, Modal, Table } from 'react-bootstrap'
import { ButtonSpinner } from '../../../../../../../components/ButtonSpinner/ButtonSpinner'
import { InputText } from '../../../../../../../components/Inputs'
import { InputSelect } from '../../../../../../../components/Inputs/InputSelect'
import { ModalStatusServer } from '../../../../../../../components/Modals/ModalStatusServer'
import { getSelectByKeys, isStatusSucess } from '../../../../../../../helpers/helpers'
import { useForm } from '../../../../../../../hooks/useForm'
import { useValidator } from '../../../../../../../hooks/useValidator'
import { useLang } from '../../../../../../../language'
import { ParametrosServices } from '../../../../../../../services/parametros.service'
import { TiposTarifaAplicadaAServices } from '../../../../../../../services/statics.service'
import { BancosServices } from '../../../../../../facturacion/pages/Parametros/services/bancos.service'
import { ServiciosLineasServices } from '../../../../../../facturacion/pages/Parametros/services/servicioslineas.services'
import { TarifasAdapters } from '../controllers/adapters/tarifas.adapter'
import { TarifasServices } from '../controllers/services/tarifas.service'
import { IVAsServices } from '../../../../../../facturacion/pages/Parametros/services/ivas.service'
import { cloneDeep } from 'lodash'
import { LoaderForm } from '../LoaderForm'

export const ModalTarifa = ({ showModal_Documento, handleCloseModal_Documento,
    fetchPersonaDatosEconomicosGET, urlParams, fetchTarifasGET, list }: any) => {

    // -------- variables 

    const Lang = useLang()

    const inputFileFichero: any = useRef(null)

    const staticTiposTarifaAplicadaA: any = TiposTarifaAplicadaAServices.GET()

    const [valuesValidationTarifa, handleValidationTarifa, handleResetValidationTarifa] = useValidator({
        tarifa: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
        precio: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })


    // --------- Parametros

    const [fetchIVAsGET, fetchIVAsGETData] = IVAsServices.GET()

    const [fetchServiciosLinea, fetchServiciosLineaData] = ServiciosLineasServices.GET()


    // -------- Formulario principal

    const [formTarifa, handleInputTarifa, handleFormTarifa, resetFormTarifa] = useForm({
        ...TarifasAdapters.GET.receive.schema({}),
    })

    // -------------------- POST Persona Entidad

    const [fetchPersonaEntidadPOST, fetchPersonaEntidadPOSTData] = TarifasServices.POST()

    const handleSubmitCrear = () => {

        if (handleValidationTarifa(formTarifa)) {

            fetchPersonaEntidadPOST({
                body: {
                    ...formTarifa,
                    idproducto: showModal_Documento.payload?.idaparato,
                    diasprecios: tarifasDias
                }
            })
        }

    }

    useEffect(() => {
        if (isStatusSucess(fetchPersonaEntidadPOSTData.status)) {
            fetchTarifasGET()
            handleCloseModal_Documento()
        }
    }, [fetchPersonaEntidadPOSTData])


    // -------------------- PATCH Persona Entidad

    const [fetchPersonaEntidadPATCH, fetchPersonaEntidadPATCHData] = TarifasServices.PATCH(showModal_Documento.payload?.form?.id)

    const handleSubmitEditar = () => {

        if (handleValidationTarifa(formTarifa)) {
            fetchPersonaEntidadPATCH({
                body: {
                    ...formTarifa,
                    idproducto: showModal_Documento.payload?.idaparato,
                    diasprecios: tarifasDias
                }
            })
        }

    }

    useEffect(() => {
        if (isStatusSucess(fetchPersonaEntidadPATCHData.status)) {
            fetchTarifasGET()
            handleCloseModal_Documento()
        }
    }, [fetchPersonaEntidadPATCHData])

    // ---------- DELETE Persona Entidad

    const [fetchPersonaEntidadDELETE, fetchPersonaEntidadDELETEData] = TarifasServices.DELETE(showModal_Documento.payload?.form?.id)

    useEffect(() => {

        if (isStatusSucess(fetchPersonaEntidadDELETEData.status)) {
            fetchTarifasGET()
            handleCloseModal_Documento()
        }
    }, [fetchPersonaEntidadDELETEData])

    const handleSubmitDELETE = () => {

        fetchPersonaEntidadDELETE()
    }

    const [listTarifasAplicadas, setlistTarifasAplicadas] = useState([]);

    // Acciones al Mostrar / Ocultar la Modal

    useEffect(() => {

        if (showModal_Documento.value) {

            if (!fetchIVAsGETData.data) {

                fetchIVAsGET({
                    params: {
                        status: 'activos'
                    }
                })
            }

            if (!fetchServiciosLineaData.data) {

                fetchServiciosLinea({
                    params: {
                        limit: 200,
                        codigo: 'slam',
                    }
                })
            }

            if (showModal_Documento.payload?.form) {

                handleFormTarifa({
                    ...showModal_Documento.payload?.form,
                })

                setTarifasDias(showModal_Documento.payload?.form?.diasprecios?.map((item: any) => {
                    return {
                        dia: item.dia,
                        precio: item.precio,
                        idproductotarifa: item.idproductotarifa,
                    }
                }))
                // setTarifasDias(showModal_Documento.payload?.form?.diasprecios)
            }

            // Relistando las tarifas aplicadas

            let listTemp: any = getSelectByKeys(staticTiposTarifaAplicadaA)
            let listTempNew: any = []            

            for (let i = 0; i < listTemp.length; i++) {
                
                if (!list?.find((item2: any) => item2.tarifaaplicadaa === listTemp[i].id) || showModal_Documento.payload?.form?.tarifaaplicadaa === listTemp[i].id) {
                 
                    listTempNew.push(listTemp[i])
                }
            }

            setlistTarifasAplicadas(listTempNew)

        } else {

            resetFormTarifa()
            handleResetValidationTarifa()
            setTarifasDias([])
        }

    }, [showModal_Documento.value])

    const [fetchBancosGET, fetchBancosGETData] = BancosServices.GET()

    useEffect(() => {
        if (formTarifa.codbanco?.length === 4) {

            fetchBancosGET({
                params: {
                    codbanco: formTarifa.codbanco
                }
            })

        } else {
            handleFormTarifa({
                ...formTarifa,
                idbanco: ''
            })
        }
    }, [formTarifa.codbanco])

    useEffect(() => {

        handleFormTarifa({
            ...formTarifa,
            idbanco: fetchBancosGETData.data?.items?.[0]?.id || ''
        })

    }, [fetchBancosGETData])


    const handleDeleteAdjunto = () => {
        handleFormTarifa({
            ...formTarifa,
            adjunto: []
        })
    }

    const handleChangeServicioAndIVA = (e: any) => {

        const res = fetchServiciosLineaData?.data?.items?.find((item: any) => item.id === e.target?.value) || {}

        handleFormTarifa({
            ...formTarifa,
            idiva: res?.iva?.idiva || '',
            [e.target.name]: e.target.value,
        })
    }

    // ---------- Calculando importe e importe IVA

    useLayoutEffect(() => {

        if (showModal_Documento.value) {

            const resIva = fetchIVAsGETData?.data?.items?.find((item: any) => item.id === formTarifa.idiva) || {}

            const ivaTemp = Number(resIva?.porcentajeiva)

            const precioTemp = Number(formTarifa.precio)

            const importeIvaTemp = (precioTemp * ivaTemp / 100) || 0            

            handleFormTarifa({
                ...formTarifa,
                importeiva: importeIvaTemp.toFixed(2),
                importe: (precioTemp + Number(importeIvaTemp.toFixed(2)))?.toFixed(2),
                porcentajeiva: ivaTemp
            })
        }
    }, [formTarifa.precio, formTarifa.idiva, fetchIVAsGETData, showModal_Documento.value])


    const [tarifasDias, setTarifasDias] = useState<any>([])

    const handleClickAgregarCondPago = () => {

        let isLastEmpty = true

        if (tarifasDias.length > 0) {
            isLastEmpty = tarifasDias[tarifasDias.length - 1]?.precio
        }

        if (isLastEmpty) {

            setTarifasDias([
                ...tarifasDias,
                {
                    dia: tarifasDias?.length + 1,
                    precio: '',
                    // idproductotarifa: showModal_Documento.payload?.form?.id
                }
            ])
        }
    }

    const handleChangeCondPago = (index: number, name: string, value: any) => {

        const tarifasDiasTemp = cloneDeep(tarifasDias)

        tarifasDiasTemp[index] = {
            ...tarifasDiasTemp[index],
            [name]: value,
        }

        setTarifasDias(tarifasDiasTemp)
    }

    const handleClickEliminarCondPago = (index: any) => {

        const tarifasDiasTemp = cloneDeep(tarifasDias)

        const res = tarifasDiasTemp.filter((item: any, index2: any) => index2 !== index)

        setTarifasDias(res)
    }

    return (
        <>
            <Modal show={showModal_Documento.value} onHide={handleCloseModal_Documento} size='lg' id='ModalRegistro'>
                <Modal.Header className='border-bottom-0 py-4'>
                    <Modal.Title className='h5'>
                        {showModal_Documento.payload?.action === 'EDIT' ? Lang('EDITAR_TARIFA') : Lang('NUEVA_TARIFA')}
                    </Modal.Title>
                    <button type="button" className="btn-close mx-0" aria-label="Close" onClick={handleCloseModal_Documento}></button>
                </Modal.Header>
                {
                    (fetchServiciosLineaData.loading || fetchIVAsGETData.loading) ?
                        <div className="p-3">
                            <LoaderForm />
                        </div>
                        :
                        <>
                            <Modal.Body className='px-4 py-0'>
                                <Form className='row'>

                                    <Form.Group className="mb-3 col-12">
                                        <InputText
                                            label={Lang('TARIFA') + ': *'}
                                            name='tarifa'
                                            value={formTarifa.tarifa}
                                            onChange={handleInputTarifa}
                                            validation={valuesValidationTarifa}
                                            fetchData={showModal_Documento.payload.action === 'EDIT' ? fetchPersonaEntidadPATCHData : fetchPersonaEntidadPOSTData}
                                        />
                                        <small className='opacity-75'>{Lang('P_MENSAJE_PUBLICO')}.</small>
                                    </Form.Group>

                                    <Form.Group className="mb-3 col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                        <InputSelect
                                            label={`${Lang('SERVICIO_LINEA')}: *`}
                                            name='idserviciolinea'
                                            value={formTarifa.idserviciolinea}
                                            onChange={handleChangeServicioAndIVA}
                                            values={fetchServiciosLineaData.data?.items?.map((item: any) => {
                                                return {
                                                    id: item.id,
                                                    nombre: item.serviciolinea,
                                                }
                                            })}
                                            fetchData={showModal_Documento.payload.action === 'EDIT' ? fetchPersonaEntidadPATCHData : fetchPersonaEntidadPOSTData}
                                            validation={valuesValidationTarifa}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3 col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                                        <InputSelect
                                            label={Lang('TARIFA_APLICADA_A') + ': *'}
                                            name='tarifaaplicadaa'
                                            value={formTarifa.tarifaaplicadaa}
                                            onChange={handleInputTarifa}
                                            values={listTarifasAplicadas}
                                            fetchData={showModal_Documento.payload.action === 'EDIT' ? fetchPersonaEntidadPATCHData : fetchPersonaEntidadPOSTData}

                                            validation={valuesValidationTarifa}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3 col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                                        <InputSelect
                                            label='IVA:'
                                            name='idiva'
                                            value={formTarifa.idiva}
                                            onChange={handleInputTarifa}
                                            values={fetchIVAsGETData.data?.items?.map((item: any) => {
                                                return {
                                                    nombre: item.iva,
                                                    id: item.id
                                                }
                                            }) || []}
                                            validation={valuesValidationTarifa}
                                            fetchData={showModal_Documento.payload.action === 'EDIT' ? fetchPersonaEntidadPATCHData : fetchPersonaEntidadPOSTData}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3 col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                                        <InputText
                                            label={Lang('PRECIO') + ':'}
                                            name='precio'
                                            type='number'
                                            value={formTarifa.precio}
                                            onChange={handleInputTarifa}
                                            validation={valuesValidationTarifa}
                                            fetchData={showModal_Documento.payload.action === 'EDIT' ? fetchPersonaEntidadPATCHData : fetchPersonaEntidadPOSTData}
                                        />
                                    </Form.Group>

                                    <div className="col-12"></div>

                                    <Form.Group className="mb-3 col-12 col-md-6 col-lg-4">
                                        <InputText
                                            label={Lang('IMPORTE') + ':'}
                                            name='importe'
                                            value={formTarifa.importe + ' €'}
                                            onChange={handleInputTarifa}
                                            // validation={valuesValidationTarifa}
                                            readonly
                                        // disabled
                                        // fetchData={showModal_Documento.payload.action === 'EDIT' ? fetchPersonaEntidadPATCHData : fetchPersonaEntidadPOSTData}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3 col-12 col-md-6 col-lg-4">
                                        <InputText
                                            label={Lang('IMPORTE_IVA') + ':'}
                                            name='importeiva'
                                            value={formTarifa.importeiva + ' €'}
                                            onChange={handleInputTarifa}
                                            // disabled
                                            // validation={valuesValidationTarifa}
                                            readonly
                                        // fetchData={showModal_Documento.payload.action === 'EDIT' ? fetchPersonaEntidadPATCHData : fetchPersonaEntidadPOSTData}
                                        />
                                    </Form.Group>

                                    <div className="col-12">
                                        <Alert variant='info' className='py-2'>
                                            Si no existeix un dia definit, es farà servir el preu per defecte
                                        </Alert>
                                    </div>

                                    <div className='col-12 mt-2'>
                                        <div className="card p-2 p-lg-4">

                                            <div className="row">
                                                <div className="col-12 mb-3">
                                                    <div className="d-flex justify-content-end">
                                                        <Button variant='primary' size='sm' className='' onClick={handleClickAgregarCondPago} >
                                                            <FontAwesomeIcon icon={faPlus} /> {Lang('PRECIO_POR_DIA')}
                                                        </Button>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <Table>
                                                        <thead>
                                                            <tr >
                                                                <th>
                                                                    <small>{Lang('DIA')}</small>
                                                                </th>
                                                                <th>
                                                                    <small>{Lang('PRECIO')}</small>
                                                                </th>
                                                                <th>
                                                                    <small className='d-block text-center'>{Lang('IMPORTE')}</small>
                                                                </th>
                                                                <th>
                                                                    <small className='d-block text-center'>{Lang('IMPORTE_IVA')}</small>
                                                                </th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                tarifasDias.map((item: any, index: number) => {
                                                                    return (
                                                                        <tr>
                                                                            <td valign="middle">
                                                                                <Form.Group className='col-12'>
                                                                                    <InputText
                                                                                        name='dia'
                                                                                        value={item.dia}
                                                                                        onChange={(e) => handleChangeCondPago(index, 'dia', e.target.value)}
                                                                                    />
                                                                                </Form.Group>
                                                                            </td>
                                                                            <td valign="middle">
                                                                                <Form.Group className='col-12' >
                                                                                    <InputText
                                                                                        name='precio'
                                                                                        value={item.precio}
                                                                                        onChange={(e) => handleChangeCondPago(index, 'precio', e.target.value)}
                                                                                    />
                                                                                </Form.Group>
                                                                            </td>
                                                                            <td valign="middle">
                                                                                <div className="mx-4 text-nowrap">
                                                                                    <InputText
                                                                                        name='dia'
                                                                                        value={(Number(item.precio) + Number((Number(Number(item.precio) * formTarifa.porcentajeiva / 100))?.toFixed(2)))?.toFixed(2) + ' €'}
                                                                                        readonly
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td valign="middle">
                                                                                <div className="mx-4 text-nowrap">
                                                                                    <InputText
                                                                                        name='dia'
                                                                                        value={(item.precio * formTarifa.porcentajeiva / 100)?.toFixed(2) + ' €'}
                                                                                        readonly
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td className='text-center shrink-td'>
                                                                                <div className='m-2'>
                                                                                    <Button variant='danger' size='sm' className='' onClick={() => handleClickEliminarCondPago(index)} >
                                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                                    </Button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                            {
                                                                tarifasDias.length === 0 && <tr>
                                                                    <td colSpan={20} className='text-center py-5'>{Lang('PARRAFO_NO_HAY_DATOS_PARA_MOSTRAR')}</td>
                                                                </tr>
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </Form>
                            </Modal.Body>
                            <Modal.Footer className='border-0 d-flex justify-content-between'>
                                {
                                    showModal_Documento.payload?.action === 'CREATE' ?
                                        <>
                                            <div></div>
                                            <ButtonSpinner
                                                variant="secondary" type="submit" className="me-2"
                                                handleSubmit={handleSubmitCrear} fetchDataLoading={[fetchPersonaEntidadPOSTData.loading]}
                                                value={Lang('GUARDAR')} icon={<FontAwesomeIcon icon={faSave} />}
                                            />
                                        </>
                                        :
                                        <>
                                            <ButtonSpinner
                                                variant="danger" type="submit" className="ms-2"
                                                handleSubmit={handleSubmitDELETE} fetchDataLoading={[fetchPersonaEntidadDELETEData.loading]}
                                                value={Lang('ELIMINAR')} icon={<FontAwesomeIcon icon={faTrash} className='me-1' />}
                                            />
                                            <ButtonSpinner
                                                variant="secondary" type="submit" className="me-2"
                                                handleSubmit={handleSubmitEditar} fetchDataLoading={[fetchPersonaEntidadPATCHData.loading]}
                                                value={Lang('GUARDAR')} icon={<FontAwesomeIcon icon={faSave} />}
                                            />
                                        </>
                                }

                            </Modal.Footer>
                        </>
                }

            </Modal>


            <ModalStatusServer fetchData={fetchPersonaEntidadPOSTData} />

            <ModalStatusServer fetchData={fetchPersonaEntidadDELETEData} />

            <ModalStatusServer fetchData={fetchPersonaEntidadPATCHData} />

        </>
    )
}
